var map = {
	"./ai_coins.png": 1498,
	"./altcoins.png": 8290,
	"./best_crypto_today.png": 1303,
	"./bullrun_coins.png": 1538,
	"./crypto_longterm.png": 4301,
	"./crypto_presale.png": 8927,
	"./fast_growing.png": 8343,
	"./meme_coins.png": 4716,
	"./new_crypto.png": 7377,
	"./penny_crypto.png": 141,
	"./trending_coins.png": 4503,
	"./upcoming_crypto.png": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1796;